// extracted by mini-css-extract-plugin
export var avatarContainer = "_90-0";
export var avatarTypingWave = "_90-i";
export var gray = "_90-f";
export var green = "_90-c";
export var icon = "_90-9";
export var image = "_90-1";
export var lg = "_90-6";
export var md = "_90-5";
export var presenceDot = "_90-b";
export var red = "_90-d";
export var sm = "_90-4";
export var status = "_90-a";
export var typingDot = "_90-h";
export var typingPill = "_90-g";
export var xl = "_90-7";
export var xs = "_90-3";
export var xxl = "_90-8";
export var xxs = "_90-2";
export var yellow = "_90-e";